export const generateModifierClasses = (
  componentClass: string,
  modifiers: any
) => {
  if (!modifiers) {
    return componentClass
  }

  return []
    .concat(modifiers)
    .map((modifier) => `${componentClass}--${modifier}`)
    .concat([componentClass])
    .join(' ')
}
